import { createDeleteIntentHighlightEffect } from '@databases/selections';

import { type SelectionEffectFeature, SelectionFeatureKeys } from '../../features/types';

export function createDeleteIntentHighlightEffectFeature(): SelectionEffectFeature {
  return {
    key: SelectionFeatureKeys.DELETE_INTENT_HIGHLIGHT_EFFECT,
    type: 'effect',
    isEnabled: (perms) => perms.canEditContent,
    factory: () => createDeleteIntentHighlightEffect(),
  };
}
